
<div class="breadcrumbs">
  <ul class="breadcrumbs__list">
    <li><a>Extras</a></li>
    <li>Referrals</li>
  </ul>
</div>
<main class="page-main">
  <div class="layout layout--central">
    <div class="layout__row">
      <!-- <div class="layout__sidecol"> -->
      <app-landing-left-sidebar [showDetails]="showDetails" (detailsShown)="setDetails($event)" ></app-landing-left-sidebar>
    <!-- </div> -->
    <div class="layout__bodycol">
      @if (!showDetails) {
        <div class="banner-slider">
          <div class="banner-slider__carousel" id="banner-slider">
            @for (page of campaign; track page) {
              <div class="banner-slider__slide">
                <div class="dash-slide">
                  <div class="dash-slide__content">
                    <div class="dash-slide__content-inner">
                      <!-- <h3 [innerHTML]="pageInfo?.referral_header"></h3>
                      <p [innerHTML]="pageInfo?.referral_body"></p> -->
                      <h3 [innerHTML]="page?.main_header"></h3><!-- max 45 chars with spaces -->
                      <p [innerHTML]="page?.main_body"></p>
                      <a href="#modal-tacs" (click)="setSelectedCampaign(page)" data-toggle="modal"><strong>T&Cs apply</strong></a>
                      <!-- <p>Get <strong>R200</strong> for every friend that gets a quote using your
                    link</p>
                    <p><small>If they open a policy, and maintain an active policy for at least
                      3 months, you’ll get an extra R600! Your friend will also get R200
                      on signup! <a href="#learn-more-modal" data-toggle="modal"><strong>T&Cs apply</strong></a></small>
                    </p> -->
                    <div class="dash-slide__copy-btn">
                      <div class="copy-btn">
                        <p>
                          <strong>
                            <!-- URL too long for mobile, so manually truncated version -->
                            <!-- <span class="d-sm-none">&hellip;invite/8bd376</span> -->
                            <span class="d-sm-none">{{shareUrl+page?.referral_campaign_id}}</span>
                            <span class="d-none d-sm-inline">{{shareUrl+page?.referral_campaign_id}}</span>
                          </strong>
                        </p>
                        <a href="javascript:;" [attr.data-copy-text]="shareUrl+page?.referral_campaign_id"
                        [attr.data-copy-text-msg]="'Link successfully copied!'" class="button button--primary">Copy</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dash-slide__img">
                  <div class="dash-slide__img-inner">
                    <img [src]="page?.campaign_image" alt="" />
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="banner-slider__paginator">
          <small id="banner-slider-paginator"></small>
        </div>
      </div>
      @if (referrals?.length === 0) {
        <div class="card card--notifications mt-20 is-active">
          <div class="card-body">
            <div class="card__empty">
              <img src="assets/img/referrals-empty.svg" alt="" class="img-responsive">
              <h4 class="mt-20">You don't have any referrals, yet</h4>
              <p>Click ‘Copy’ above to get started and share the love</p>
            </div>
          </div>
        </div>
      }
      @if (summary?.length > 0 && referrals?.length > 0) {
        <div class="referrals-last-updated">
          <div class="icon-cards mt-20">
            <li class="icon-cards__item">
              <div class="icon-cards__icon">
                <img [src]="summary[0]?.img_url" class="icon" alt="">
              </div>
              <div class="icon-cards__label">
                <small>{{summary[0]?.header}}</small>
                <p>
                  <strong>{{summary[0]?.value}}</strong>
                </p>
              </div>
            </li>
            <a href="javascript:;" class="icon-cards__item">
              <div class="icon-cards__icon">
                <img [src]="summary[1]?.img_url"  class="icon" alt="">
              </div>
              <div class="icon-cards__label">
                <small>{{summary[1]?.header}}</small>
                <p>
                  <strong >{{summary[1]?.value}}</strong>
                </p>
              </div>
              <div class="icon-cards__caret">
                <svg class="icon">
                  <use xlink:href="#chevron-right"></use>
                </svg>
              </div>
            </a>
            <li class="icon-cards__item">
              <div class="icon-cards__icon">
                <img [src]="summary[2]?.img_url" class="icon" alt="">
              </div>
              <div class="icon-cards__label">
                <small>{{summary[2]?.header}}</small>
                <p>
                  <strong>{{summary[2]?.value}}</strong>
                </p>
              </div>
            </li>
          </div>
          <small>{{summary[3]?.value}}</small>
        </div>
      }
      @if (referrals?.length > 0) {
        <div  class="card card--overview mt-20">
          <div class="card-title">
            <h4>
              Track your referrals
            </h4>
          </div>
          <div class="card-body">
            <ul class="data data--referrals">
              @for (referral of referrals; track referral; let i = $index) {
                @if (i < 5) {
                  <li class="data__row" (click)="setReferral(referral)">
                    <div class="data__cell data__cell--tag">
                      <span class="tag-pill tag-pill--info">{{referral?.quote_status_val}}</span>
                    </div>
                    <div class="data__cell data__cell--name">
                      <p>{{referral?.referral_name_surname}}</p>
                    </div>
                    <div class="data__cell data__cell--email">
                      <p>{{referral?.referral_email}}</p>
                    </div>
                    <div class="data__cell data__cell--campaign">
                      <p>{{referral?.referral_campaign_name}}</p>
                    </div>
                    <div class="data__cell data__cell--time">
                      <p><small>{{referral?.referral_date_difference}}</small></p>
                    </div>
                  </li>
                }
              }
            </ul>
            @if (referrals?.length > 5) {
              <div class="mt-20 text-center text-lg-left">
                <a href="javascript:;" (click)="showDetails = true" class="button-control"><strong>Show more</strong></a>
              </div>
            }
          </div>
        </div>
      }
    }
    @if (showDetails && referrals?.length > 0) {
      <div class="central-filter central-filter--no-underline">
        <div class="central-filter__label">
          <h3>{{referrals?.length }} referrals</h3>
        </div>
        <div class="central-filter__controls">
          <div class="central-filter__filter d-none d-md-flex">
            <div class="dropdown dropdown--central dropdown--persist" id="status-filter">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" id="status-filter-btn">
                Filters
              (1) </a>
              <div class="dropdown-menu dropdown-menu-right filter-list__scrollable" aria-labelledby="status-filter-btn">
                <div class="filter-list__content">
                  <div class="filter-list__heading">Status</div>
                  <ul class="filter-list filter-list--central list-unstyled" id="status-filter-list">
                    <li>
                      <label class="custom-input custom-input--checkbox">
                        <input type="checkbox" checked="" value="all" name="status-filter[]">
                        <span class="custom-input__indi"></span>
                        <span class="custom-input__label">All statuses</span>
                      </label>
                    </li>
                    <li>
                      <label class="custom-input custom-input--checkbox">
                        <input type="checkbox" value="quote" name="status-filter[]">
                        <span class="custom-input__indi"></span>
                        <span class="custom-input__label">Quote</span>
                      </label>
                    </li>
                    <li>
                      <label class="custom-input custom-input--checkbox">
                        <input type="checkbox" value="policy" name="status-filter[]">
                        <span class="custom-input__indi"></span>
                        <span class="custom-input__label">Policy</span>
                      </label>
                    </li>
                    <li>
                      <label class="custom-input custom-input--checkbox">
                        <input type="checkbox" value="earned" name="status-filter[]">
                        <span class="custom-input__indi"></span>
                        <span class="custom-input__label">Earned</span>
                      </label>
                    </li>
                  </ul>
                  <div class="filter-list__heading">Last action</div>
                  <ul class="filter-list filter-list--central list-unstyled" id="sort-filter-list">
                    <li>
                      <label class="custom-input custom-input--radio">
                        <input type="radio" checked="" value="asc" name="sort-filter[]">
                        <span class="custom-input__indi"></span>
                        <span class="custom-input__label">Ascending</span>
                      </label>
                    </li>
                    <li>
                      <label class="custom-input custom-input--radio">
                        <input type="radio" value="dsc" name="sort-filter[]">
                        <span class="custom-input__indi"></span>
                        <span class="custom-input__label">Descending</span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="filter-list__button">
                  <a href="#" id="status-filter-apply" class="button button--primary button--block">Apply
                  Filters</a>
                </div>
              </div>
            </div>
          </div>
          <div class="central-filter__filter d-md-none">
            <a href="#modal-traymenu-filters" data-toggle="modal" class="icon-hover">
              <svg class="icon">
                <use xlink:href="#filter"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="card card--overview mt-20">
        <div class="card-body pt-20">
          <ul class="data data--referrals">
            @for (referral of referrals; track referral) {
              <li class="data__row" (click)="setReferral(referral)">
                <div class="data__cell data__cell--tag">
                  <span class="tag-pill tag-pill--info">Quote</span>
                </div>
                <div class="data__cell data__cell--name">
                  <p>{{referral?.referral_name_surname}}</p>
                </div>
                <div class="data__cell data__cell--email">
                  <p>{{referral?.referral_string}}</p>
                </div>
                <div class="data__cell data__cell--campaign">
                  <p>{{referral?.referral_campaign_name}}</p>
                </div>
                <div class="data__cell data__cell--time">
                  <p><small>{{referral?.referral_date_difference}}</small></p>
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    }

  </div>
</div>
</div>
</main>
<div class="sidesheet" id="sidesheet">
  <div class="sidesheet__inner">
    <div class="sidesheet__header">
      <a href="javascript:;" class="sidesheet__header-back">
        <svg class="icon">
          <use xlink:href="#arrow-left-small"></use>
        </svg>
      </a>
      <h5>Details</h5>
    </div>
    <div class="sidesheet__body">
      @if (selectedReferral?.quote_status_code === 'earned') {
        <div class="notice notice--highlight mb-20">
          <div class="notice__content">
            <p>
              You earned
              <strong>{{selectedReferral?.reward_total}}</strong>!
            </p>
          </div>
          <!-- <a href="javascript:;" [routerLink]="['/'+RouterLinks.Wallet]" class="button button--highlight button--md button--no-min">View wallet</a> -->
        </div>
      }

      <div class="mb-20">
        <h5 class="mb-10">Who was invited?</h5>
        <p>{{selectedReferral?.referral_name_surname}} ({{selectedReferral?.referral_email}})</p>
        <hr class="hr--bdr hr--xs-md">
      </div>

      @if (selectedReferral?.progress_json) {
        <div class="mb-20">
          <h5 class="mb-10">Progress</h5>
          <div class="progress-tree-simple">
            @for (stage of selectedReferral?.progress_json; track stage) {
              <div class="progress-tree-simple__item " [ngClass]="stage?.progress_stage_state === 0 ? 'is-incomplete':'is-complete'">
                <div class="progress-tree-simple__branch">
                  <span><span></span></span>
                </div>
                <div class="progress-tree-simple__content">
                  <div class="progress-tree-simple__title">
                    <h6>{{stage?.progress_stage_name}}</h6>
                    <p>{{stage?.progress_stage_subtext}}</p>
                  </div>
                </div>
              </div>
            }
            <!-- <div class="progress-tree-simple__item is-incomplete">
            <div class="progress-tree-simple__branch">
              <span><span></span></span>
            </div>
            <div class="progress-tree-simple__content">
              <div class="progress-tree-simple__title">
                <h6>Invited</h6>
              </div>
            </div>
          </div>
          <div class="progress-tree-simple__item is-incomplete">
            <div class="progress-tree-simple__branch">
              <span><span></span></span>
            </div>
            <div class="progress-tree-simple__content">
              <div class="progress-tree-simple__title">
                <h6>Friend keeps their policy active for 3 months</h6>
                <p>You earn an extra R 600</p>
              </div>
            </div>
          </div> -->
        </div>
        <hr class="hr--bdr hr--xs-md">
      </div>
    }

    <div class="mb-20">
      <div class="note note--info">
        <div class="note__content">
          <h6 [innerHTML]="selectedReferral?.referral_campaign_name"></h6>
          <p [innerHTML]="selectedReferral?.referral_campaign_description_html" ></p>
        </div>
      </div>
    </div>

    <div class="rte small">
      <p><strong>{{selectedReferral?.referral_campaign_terms_header}}</strong></p>
      <p [innerHTML]="selectedReferral?.referral_campaign_terms_html"></p>
    </div>

  </div>
</div>
</div>

<div class="modal fade modal--alert" id="share-email-modal" tabindex="-1" role="dialog" aria-labelledby="share-email-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <a href="#refer-friends-modal" class="modal-alert__back" data-toggle="modal" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#arrow-left-small"></use></svg>
            <strong>&nbsp; Back</strong>
          </a>
          <div class="modal-alert__avatar">
            <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Share via email</h3>
          </div>

          @for (email of emailControl; track email) {
            <div class="form-group has-action">
              <input type="email" value="" data-msg-error="Please enter a valid email address" placeholder="{{email?.placeholder}}" class="form-control emails">
              <a href="javascript:;" (click)="pop()" class="form-group__append action-clear">
                <svg class="icon"><use xlink:href="#trash"></use></svg>
              </a>
            </div>
          }
          <a href="javascript:;" (click)="push()" class="form-group__append action-clear">
            <svg class="icon"><use xlink:href="#plus"></use></svg>
          </a>
        </div>
        <br>
          <a href="#view-email-modal"  data-toggle="modal" >View email content</a>


        </div>

        <div class="modal-alert__button">
          <div class="container">
            <a href="javascript:void(0);" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" disabled="" (click)="sendEmail()" class="button button--lg button--primary" data-dismiss="modal" id="send-invites-btn">Send Invites</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal--alert" id="modal-tacs" tabindex="-1" role="dialog" aria-labelledby="learn-more-modal" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-alert modal-alert--sm">
        <div class="modal-alert__heading">
          <div class="container">
            <div class="modal-alert__avatar">
              <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
            </div>
            <button class="modal-alert__close" data-dismiss="modal">
              <svg class="icon"><use xlink:href="#close-medium"></use></svg>
            </button>
          </div>
        </div>

        <div class="modal-alert__content">
          <div class="container">
            <h4 [innerHTML]="selectedtCampaign?.tc_header"></h4>
            <div class="rte">
              <div class="text-left">
                <p [innerHTML]="selectedtCampaign?.tc_body">
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-alert__button">
          <div class="container">
            <a href="javascript:void(0);" class="button button--lg button--primary" data-dismiss="modal">{{selectedtCampaign?.tc_button_text}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade modal--alert" id="view-email-modal" tabindex="-1" role="dialog" aria-labelledby="learn-more-modal" style="display: none;" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-alert modal-alert--sm">
        <div class="modal-alert__heading">
          <div class="container">
            <div class="modal-alert__avatar">
              <img src="/assets/0/avatar/happy.png" class="img-fluid" alt="">
            </div>
            <button class="modal-alert__close" data-dismiss="modal">
              <svg class="icon"><use xlink:href="#close-medium"></use></svg>
            </button>
          </div>
        </div>

        <div class="modal-alert__content">
          <div class="container">
            <h4></h4>
            <div class="rte">
              <img src="https://assets.everything.insure/referee.png" />
            </div>
          </div>
        </div>

        <!-- <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" class="button button--lg button--primary" (click)="sendEmail()" data-dismiss="modal">Send</a>
        </div>
      </div> -->
    </div>
  </div>
</div>
<div class="modal fade modal--tray " id="modal-traymenu-filters" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-filters" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu modal-traymenu--fs">
      <div class="modal-traymenu__header">
        <div class="container">
          <h6>Filters</h6>
          <a href="#" class="modal-traymenu__header-clear">Clear</a>
          <a href="#" data-dismiss="modal" class="modal-traymenu__header-close">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-traymenu__filters">
        <div class="container">
          <div class="filter-list__heading">Status</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-status-filter-list">
            <li>
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" checked="" value="all" name="status-filter-mobile[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">All statuses</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" value="quote" name="status-filter-mobile[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Quote</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" value="policy" name="status-filter-mobile[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Policy</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" value="earned" name="status-filter-mobile[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Earned</span>
              </label>
            </li>
          </ul>
          <div class="filter-list__heading">Premium Order</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-sort-filter-list">
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" checked="" value="asc" name="sort-filter-mobile[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Ascending</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" value="dsc" name="sort-filter-mobile[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Descending</span>
              </label>
            </li>
          </ul>
        </div>
      </div>

      <div class="modal-traymenu__btn">
        <div class="container">
          <a href="#" data-dismiss="modal" class="button button--primary button--block">Apply</a>
        </div>
      </div>
    </div>
  </div>
</div>